import React from 'react';
import { Check, Clock, Shield, Users, Car, MapPin } from 'lucide-react';
import videoPoster from '../Assets/video1.mp4';

// Import vehicle images (make sure these files exist in your Assets folder)
import sedanImage from '../Assets/sedan.webp';
import suvImage from '../Assets/WhatsApp Image 2025-10-06 at 8.06.53 PM.jpeg';
import innovaImage from '../Assets/Innova (1).png';
import tempoImage from '../Assets/tempo.jpg';
import urbaniaImage from '../Assets/urbania.jpg';
import luxuryImage from '../Assets/Audi A8 L.jpeg';
import logo from "../Assets/taxi (2).png"
import hondaCityImage from "../Assets/honda_city_platinum_white_pearl.webp"
import kiaCarensImage from "../Assets/20250808114824_Kia_Carens_Sparkling_Silver[1].avif"

const AboutUs = () => {
  // WhatsApp configuration
  const whatsappNumber = '919100390049'; // Replace with your actual WhatsApp number
  const companyName = 'Shree Puja Travels';

  // Function to open WhatsApp with pre-filled message
  const openWhatsApp = (vehicleDetails) => {
    const message = `Hello ${companyName}! I'm interested in booking a ${vehicleDetails.title}. 
    
Vehicle Details:
- Type: ${vehicleDetails.title}
- Capacity: ${vehicleDetails.capacity}
- Description: ${vehicleDetails.description}
- Features: ${vehicleDetails.features.join(', ')}

Please provide me with more information and availability.`;
    
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  const fleetData = [
    {
      title: "Sedans",
      description: "Perfect for city commutes, airport transfers, and business travel. Models include Toyota Etios, Swift Dzire and similar.",
      capacity: "Up to 4 passengers",
      features: ["AC", "Fuel Efficient", "Affordable Pricing", "Experienced Driver"],
      icon: <Car size={24} />,
      color: "bg-blue-50 border-blue-100",
      image: sedanImage,
      price: "Starting from ₹14/km"
    },
    {
  title: "Honda City",
  description: "Premium sedan offering superior comfort, style, and performance for business meetings, family trips, and executive travel.",
  capacity: "Up to 4 passengers",
  features: ["Premium AC",  "Powerful Engine", "Professional Chauffeur", "Infotainment System"],
  icon: <Car size={24} />,
  color: "bg-silver-50 border-silver-200",
  image: hondaCityImage,
  price: "Starting from ₹14/km"
},
    // {
    //   title: "SUVs",
    //   description: "Ideal for families or small groups seeking extra space for weekend getaways or hilly terrains.",
    //   capacity: "6-7 seater",
    //   features: ["Ample Luggage Space", "Powerful Engine", "Smooth Ride", "Hill Station Ready"],
    //   icon: <Car size={24} />,
    //   color: "bg-green-50 border-green-100",
    //   image: suvImage,
    //   price: "Starting from ₹18/km"
    // },
    {
  title: "Kia Carens",
  description: "Versatile SUV with 3-row seating, perfect for family vacations, group outings, and spacious comfort for long journeys.",
  capacity: "Up to 6 passengers",
  features: ["Spacious 3-Row", "Premium AC", "Child Seat Option"],
  icon: <Car size={24} />,
  color: "bg-green-50 border-green-100",
  image: kiaCarensImage,
  price: "Starting from ₹18/km"
},
    {
      title: "Innova Crysta",
      description: "The preferred premium MPV for family vacations and corporate travel.",
      capacity: "6/7 seater options",
      features: ["Plush Interiors", "Dual AC", "Stable Ride", "Premium Experience"],
      icon: <Car size={24} />,
      color: "bg-purple-50 border-purple-100",
      image: innovaImage,
      price: "Starting from ₹22/km"
    },
    {
  title: "Toyota Innova Hycross",
  description: "Premium MPV with executive comfort, ideal for corporate travel and family trips.",
  capacity: "7 seaters",
  features: ["Leather Seats", "Climate Control", "Premium Audio", "Spacious Cabin"],
  icon: <Car size={24} />,
  color: "bg-gray-50 border-gray-100",
  image: 'https://static.toyotabharat.com/images/showroom/innova-hycross/avant-garde-bronze.png',
  price: "Starting from ₹25/km"
},
    {
      title: "Tempo Travellers",
      description: "Designed for group tours, pilgrimage yatras, and educational outings.",
      capacity: "9-26 seaters",
      features: ["Push-back Seats", "AC/Non-AC", "Music System", "Driver + Helper"],
      icon: <Users size={24} />,
      color: "bg-amber-50 border-amber-100",
      image: tempoImage,
      price: "Starting from ₹30/km"
    },
    {
      title: "Force Urbania",
      description: "Premium luxury van for corporate teams, wedding parties, and airport shuttles.",
      capacity: "13-17 seaters",
      features: ["Luxury Seats", "USB Ports", "Premium Cabin", "Enhanced Safety"],
      icon: <Car size={24} />,
      color: "bg-cyan-50 border-cyan-100",
      image: urbaniaImage,
      price: "Starting from ₹40/km"
    },
    {
      title: "Luxury Cars",
      description: "Travel in ultimate style with chauffeur-driven luxury vehicles.",
      capacity: "VIP seating",
      features: ["Premium Brands", "Chauffeur Service", "Executive Class", "Special Events"],
      icon: <Car size={24} />,
      color: "bg-pink-50 border-pink-100",
      image: luxuryImage,
      price: "Starting from ₹50/km"
    },
    
{
  title: "Mercedes Benz V-Class",
  description: "Ultimate luxury van experience with business-class amenities and premium finishes.",
  capacity: "7 seaters",
  features: ["Executive Seats", "Ambient Lighting", "Privacy Partitions", "Premium Entertainment"],
  icon: <Car size={24} />,
  color: "bg-silver-50 border-silver-200",
  image: 'https://imgd-ct.aeplcdn.com/664x415/n/fmdg6sa_1475344.jpg?q=80',
  price: ""
},
{
  title: "BMW 7 Series",
  description: "Flagship luxury sedan with cutting-edge technology and supreme comfort.",
  capacity: "5 seaters",
  features: ["Massage Seats", "Panoramic Roof", "Bowers & Wilkins Audio", "Executive Lounge"],
  icon: <Car size={24} />,
  color: "bg-blue-50 border-blue-100",
  image: 'https://imgd.aeplcdn.com/664x374/n/cw/ec/132513/new-7-series-exterior-right-front-three-quarter.jpeg?isig=0&q=80',
  price: ""
},
{
  title: "Mercedes S-Class",
  description: "The pinnacle of automotive luxury with unparalleled comfort and technology.",
  capacity: "5 seaters",
  features: ["Executive Rear Seats", "Burmester 4D Sound", "MAGIC BODY CONTROL", "Ambient Air System"],
  icon: <Car size={24} />,
  color: "bg-gray-50 border-gray-200",
  image: 'https://stimg.cardekho.com/images/carexteriorimages/630x420/Mercedes-Benz/S-Class/10852/1763536912245/front-left-side-47.jpg?imwidth=420&impolicy=resize',
  price: ""
},
{
  title: "Mercedes E-Class",
  description: "Business luxury sedan combining elegance with advanced technology.",
  capacity: "5 seaters",
  features: ["Dual Screen Dashboard", "Energizing Comfort", "MBUX System", "Premium Package"],
  icon: <Car size={24} />,
  color: "bg-slate-50 border-slate-200",
  image: 'https://stimg.cardekho.com/images/carexteriorimages/630x420/Mercedes-Benz/E-Class/9790/1763471140336/front-left-side-47.jpg?tr=w-320',
  price: ""
},
{
  title: "BMW X5",
  description: "Luxury Sports Activity Vehicle offering premium comfort and dynamic performance.",
  capacity: "7 seaters",
  features: ["Vernasca Leather", "Panoramic Sky Lounge", "Live Cockpit Professional", "Air Suspension"],
  icon: <Car size={24} />,
  color: "bg-sky-50 border-sky-100",
  image: 'data:image/jpeg;base64,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',
  price: ""
}
  ];

  const airportFeatures = [
    "24/7 Service for all flights",
    "On-time pickup guarantee",
    "Clean & sanitized vehicles",
    "Professional chauffeurs",
    "Transparent fixed pricing",
    "Meet & greet service available"
  ];

  // Function to open WhatsApp for airport taxi
  const openWhatsAppAirportTaxi = () => {
    const message = `Hello ${companyName}! I'm interested in booking an airport taxi service. 
    
I need transfer to/from RGIA Airport Hyderabad.
Please provide me with:
1. Available vehicles for airport transfer
2. Pricing details
3. Booking procedure
4. Any special requirements`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  // Function to open WhatsApp for general booking
  const openWhatsAppGeneral = (serviceType) => {
    const message = `Hello ${companyName}! I'm interested in ${serviceType}. 
    
Please provide me with:
1. Available options
2. Pricing details
3. Booking procedure
4. Any special offers`;

    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section with Video */}
       <div className="relative w-full min-h-screen overflow-hidden bg-gradient-to-br from-sky-50 via-blue-50 to-indigo-100">
      {/* Video - Commented as requested */}
      {/* <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src={videoPoster} type="video/mp4" />
      </video> */}
      
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-blue-200/40 to-purple-200/40 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-gradient-to-tl from-indigo-200/40 to-pink-200/40 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-r from-cyan-100/30 to-blue-100/30 rounded-full blur-3xl"></div>
      </div>

      {/* Pattern Overlay */}
      <div className="absolute inset-0 opacity-5" style={{backgroundImage: 'radial-gradient(circle, #000 1px, transparent 1px)', backgroundSize: '50px 50px'}}></div>
      
      {/* Content Container */}
      <div className="relative container mx-auto px-4 md:px-6 min-h-screen flex items-center justify-center z-10 py-8">
        <div className="max-w-6xl mx-auto text-center space-y-6 md:space-y-8">
          
          {/* Top Badge */}
          {/* <div className="inline-flex items-center gap-2 md:gap-3 px-4 md:px-6 py-2 md:py-3 bg-white rounded-full shadow-lg border border-blue-100 mb-2 md:mb-4">
            <div className="flex items-center gap-1.5 md:gap-2">
              <svg className="w-4 h-4 md:w-5 md:h-5 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
              <span className="text-xs md:text-sm font-semibold text-gray-700">Premium Since 2010</span>
            </div>
          </div> */}
          
          {/* Main Heading with Icon */}
          <div className="space-y-3 md:space-y-4">
            <div className="flex items-center justify-center gap-3 md:gap-4 mb-4 md:mb-6">
              <div className="w-10 md:w-16 h-0.5 md:h-1 bg-gradient-to-r from-transparent to-gray-900 rounded-full"></div>
              <img src={logo} alt="Shree Puja Travels Logo" className="w-10 h-10 md:w-16 md:h-16 object-contain"/>
              <div className="w-10 md:w-16 h-0.5 md:h-1 bg-gradient-to-l from-transparent to-gray-900 rounded-full"></div>
            </div>
            
            <h1 className="text-4xl md:text-7xl lg:text-8xl font-bold leading-tight px-2">
              <span className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent"style={{ color: 'rgba(65, 1, 150, 1)' }} >
                Shree Puja Travels
              </span>
            </h1>
          </div>
          
          {/* Subheading */}
          <div className="space-y-3 md:space-y-5 max-w-3xl mx-auto px-4">
            <p className="text-xl md:text-3xl lg:text-4xl font-bold text-gray-800">
              Hyderabad's Most Trusted Travel Partner
            </p>
            <p className="text-sm md:text-lg lg:text-xl text-gray-600 leading-relaxed">
              Delivering excellence in every journey with our premium fleet, professional drivers, 
              and unwavering commitment to your comfort and safety.
            </p>
          </div>
          
          {/* Feature Cards - Mobile App Style */}
          <div className="grid grid-cols-3 gap-3 md:gap-6 max-w-4xl mx-auto py-4 md:py-8 px-2">
            <div className="bg-white/80 backdrop-blur-sm rounded-xl md:rounded-2xl p-3 md:p-6 shadow-lg md:shadow-xl border border-blue-100 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
              <div className="w-10 h-10 md:w-14 md:h-14 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg md:rounded-xl flex items-center justify-center mx-auto mb-2 md:mb-4">
                <svg className="w-5 h-5 md:w-7 md:h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-lg md:text-2xl font-bold text-gray-800 mb-1 md:mb-2">15+</h3>
              <p className="text-gray-600 text-xs md:text-sm">Years</p>
            </div>
            
            <div className="bg-white/80 backdrop-blur-sm rounded-xl md:rounded-2xl p-3 md:p-6 shadow-lg md:shadow-xl border border-purple-100 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
              <div className="w-10 h-10 md:w-14 md:h-14 bg-gradient-to-br from-purple-500 to-purple-600 rounded-lg md:rounded-xl flex items-center justify-center mx-auto mb-2 md:mb-4">
                <svg className="w-5 h-5 md:w-7 md:h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-lg md:text-2xl font-bold text-gray-800 mb-1 md:mb-2">50K+</h3>
              <p className="text-gray-600 text-xs md:text-sm">Customers</p>
            </div>
            
            <div className="bg-white/80 backdrop-blur-sm rounded-xl md:rounded-2xl p-3 md:p-6 shadow-lg md:shadow-xl border border-indigo-100 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
              <div className="w-10 h-10 md:w-14 md:h-14 bg-gradient-to-br from-indigo-500 to-indigo-600 rounded-lg md:rounded-xl flex items-center justify-center mx-auto mb-2 md:mb-4">
                <svg className="w-5 h-5 md:w-7 md:h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-lg md:text-2xl font-bold text-gray-800 mb-1 md:mb-2">24/7</h3>
              <p className="text-gray-600 text-xs md:text-sm">Support</p>
            </div>
          </div>
          
          {/* CTA Buttons - Mobile App Style */}
          <div className="flex flex-col gap-3 md:gap-5 md:flex-row justify-center pt-4 md:pt-6 px-4">
            <button 
              onClick={() => openWhatsAppGeneral("booking a vehicle")}
              className="group relative w-full md:w-auto px-8 md:px-10 py-4 md:py-5 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold text-base md:text-lg rounded-xl md:rounded-2xl shadow-lg md:shadow-xl hover:shadow-2xl transition-all duration-300 transform active:scale-95 md:hover:scale-105 overflow-hidden" style={{ background: 'rgba(65, 1, 150, 1)' }}
            >
              <span className="relative z-10 flex items-center justify-center gap-2 md:gap-3">
                <svg className="w-5 h-5 md:w-6 md:h-6" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                <span>Book Your Journey</span>
                <svg className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </span>
              <div className="absolute inset-0 bg-gradient-to-r from-indigo-700 to-purple-700 transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-300"></div>
            </button>
            
            <button 
              onClick={() => openWhatsAppGeneral("your services")}
              className="w-full md:w-auto px-8 md:px-10 py-4 md:py-5 bg-white text-gray-900 font-bold text-base md:text-lg rounded-xl md:rounded-2xl shadow-lg md:shadow-xl hover:shadow-2xl border-2 border-blue-200 hover:border-blue-400 transition-all duration-300 transform active:scale-95 md:hover:scale-105"
            >
              <span className="flex items-center justify-center gap-2">
                <svg className="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
                <span>View All Services</span>
              </span>
            </button>
          </div>
          
          {/* Trust Badges - Mobile Optimized */}
          <div className="flex flex-col md:flex-row flex-wrap items-center justify-center gap-4 md:gap-8 pt-6 md:pt-8 px-4">
            <div className="flex items-center gap-2 text-gray-700">
              <div className="w-8 h-8 md:w-10 md:h-10 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                <svg className="w-4 h-4 md:w-5 md:h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <span className="font-medium text-sm md:text-base">Certified & Licensed</span>
            </div>
            <div className="flex items-center gap-2 text-gray-700">
              <div className="w-8 h-8 md:w-10 md:h-10 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                <svg className="w-4 h-4 md:w-5 md:h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <span className="font-medium text-sm md:text-base">GPS Tracked Fleet</span>
            </div>
            <div className="flex items-center gap-2 text-gray-700">
              <div className="w-8 h-8 md:w-10 md:h-10 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                <svg className="w-4 h-4 md:w-5 md:h-5 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <span className="font-medium text-sm md:text-base">Professional Drivers</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator - Hidden on mobile */}
     
    </div>

      <div className="container mx-auto px-4 py-12">
        {/* Story Section */}
        <section className="mb-16">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">
              Our Story & Commitment
            </h2>
            <div className="bg-white rounded-2xl shadow-lg p-8">
              <p className="text-gray-600 mb-6 leading-relaxed">
                Founded on the principles of trust and service excellence, Shree Puja Travels began with a simple mission: to transform travel in Hyderabad from a mundane necessity into a seamless experience. Over the years, we have grown by listening to our customers and adapting to their needs.
              </p>
              <p className="text-gray-600 mb-6 leading-relaxed">
                Our commitment extends beyond just getting you from point A to point B. We focus on the details that matter—impeccably maintained and sanitized vehicles, professional and courteous drivers, transparent pricing with no hidden charges, and 24/7 customer support.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
                <div className="flex items-center space-x-4">
                  <div className="bg-blue-100 p-3 rounded-full">
                    <Shield className="text-blue-600" size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">Trust & Safety</h3>
                    <p className="text-sm text-gray-600">Verified drivers and insured vehicles</p>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="bg-green-100 p-3 rounded-full">
                    <Clock className="text-green-600" size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">Punctuality</h3>
                    <p className="text-sm text-gray-600">On-time service guaranteed</p>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="bg-purple-100 p-3 rounded-full">
                    <Users className="text-purple-600" size={24} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">Customer First</h3>
                    <p className="text-sm text-gray-600">24/7 support for all queries</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Fleet Section */}
        <section className="mb-16">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Our Comprehensive Fleet</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              We understand that different journeys require different solutions. Choose from our diverse range of well-maintained vehicles.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {fleetData.map((vehicle, index) => (
              <div key={index} className={`border-2 ${vehicle.color} rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300 hover:scale-[1.02]`}>
                {/* Vehicle Image */}
                <div className="h-48 w-full overflow-hidden">
                  <img 
                    src={vehicle.image} 
                    alt={vehicle.title}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = `https://images.unsplash.com/photo-${index === 0 ? '1549399542-7e3f8b79c341' : 
                        index === 1 ? '1563720223485-41e72d6f9d3c' : 
                        index === 2 ? '1563720223485-41e72d6f9d3c' : 
                        index === 3 ? '1563720223485-41e72d6f9d3c' : 
                        index === 4 ? '1563720223485-41e72d6f9d3c' : 
                        '1563720223485-41e72d6f9d3c'}?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80`;
                    }}
                  />
                </div>
                
                <div className="p-6">
                  <div className="flex items-center justify-between mb-4">
                    <div className="bg-white p-3 rounded-lg">
                      {vehicle.icon}
                    </div>
                    <span className="px-3 py-1 bg-white rounded-full text-sm font-medium">
                      {vehicle.capacity}
                    </span>
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-800 mb-3">{vehicle.title}</h3>
                  <p className="text-gray-600 mb-4">{vehicle.description}</p>
                  
                  {/* Price Tag */}
                  <div className="mb-4">
                    <span className="inline-block px-3 py-1 bg-gradient-to-r from-green-100 to-green-50 text-green-700 font-bold rounded-full text-sm">
                      {vehicle.price}
                    </span>
                  </div>
                  
                  <div className="space-y-2 mb-6">
                    {vehicle.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center">
                        <Check size={16} className="text-green-500 mr-2" />
                        <span className="text-sm text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                  
                  <button 
                    onClick={() => openWhatsApp(vehicle)}
                    className="w-full py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg font-medium hover:from-blue-700 hover:to-blue-800 transition-all duration-300 flex items-center justify-center gap-2"style={{ background: 'rgba(65, 1, 150, 1)' }}
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.76.982.998-3.675-.236-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.9 6.994c-.004 5.45-4.438 9.88-9.888 9.88m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.333.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.333 11.893-11.893 0-3.18-1.24-6.162-3.495-8.411"/>
                    </svg>
                    Book {vehicle.title}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Airport Service Section */}
        <section className="mb-16">
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl p-8 text-white"style={{ background: 'rgba(65, 1, 150, 1)' }}>
            <div className="flex flex-col lg:flex-row items-center justify-between">
              <div className="lg:w-2/3 mb-8 lg:mb-0 lg:pr-12">
                <h2 className="text-3xl font-bold mb-4">
                  Airport Taxi Service
                </h2>
                <p className="text-blue-100 mb-6">
                  We make airport travel stress-free. Our dedicated Hyderabad airport cab service to and from RGIA guarantees reliability, comfort, and punctuality for all your flights.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  {airportFeatures.map((feature, index) => (
                    <div key={index} className="flex items-center">
                      <Check size={18} className="mr-2" />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="lg:w-1/3">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                  <h3 className="text-xl font-bold mb-4">RGIA Airport Transfers</h3>
                  <div className="space-y-4">
                    {fleetData.slice(0, 3).map((vehicle, index) => (
                      <div key={index} className="flex justify-between items-center">
                        <span className="text-blue-100">{vehicle.title}</span>
                        <span className="font-bold">{vehicle.price}</span>
                      </div>
                    ))}
                  </div>
                  <button 
                    onClick={openWhatsAppAirportTaxi}
                    className="mt-6 w-full bg-white text-blue-600 py-3 rounded-lg font-bold hover:bg-blue-50 transition-colors flex items-center justify-center gap-2"
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.76.982.998-3.675-.236-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.9 6.994c-.004 5.45-4.438 9.88-9.888 9.88m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.333.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.333 11.893-11.893 0-3.18-1.24-6.162-3.495-8.411"/>
                    </svg>
                    Book Airport Taxi
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Vision & Mission Section */}
        <section className="mb-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Vision Card */}
            <div className="bg-gradient-to-br from-purple-50 to-white border border-purple-100 rounded-2xl p-8">
              <div className="flex items-center mb-6">
                <div className="bg-gradient-to-r from-purple-500 to-purple-600 p-3 rounded-full mr-4">
                  <MapPin className="text-white" size={24} />
                </div>
                <h3 className="text-2xl font-bold text-gray-800">Our Vision</h3>
              </div>
              <p className="text-gray-700 text-lg leading-relaxed">
                To become South India's most trusted and customer-centric travel partner, setting new benchmarks in comfort, safety, and service excellence within the taxi and travel industry.
              </p>
            </div>

            {/* Mission Card */}
            <div className="bg-gradient-to-br from-blue-50 to-white border border-blue-100 rounded-2xl p-8">
              <div className="flex items-center mb-6">
                <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-3 rounded-full mr-4">
                  <Shield className="text-white" size={24} />
                </div>
                <h3 className="text-2xl font-bold text-gray-800">Our Mission</h3>
              </div>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <div className="bg-blue-100 p-1 rounded-full mr-3 mt-1">
                    <Check size={14} className="text-blue-600" />
                  </div>
                  <span>Provide dependable, safe, and punctual taxi services for every need</span>
                </li>
                <li className="flex items-start">
                  <div className="bg-blue-100 p-1 rounded-full mr-3 mt-1">
                    <Check size={14} className="text-blue-600" />
                  </div>
                  <span>Maintain a modern, sanitized fleet for every traveler's requirement</span>
                </li>
                <li className="flex items-start">
                  <div className="bg-blue-100 p-1 rounded-full mr-3 mt-1">
                    <Check size={14} className="text-blue-600" />
                  </div>
                  <span>Make pilgrimage and family tours comfortable for all age groups</span>
                </li>
                <li className="flex items-start">
                  <div className="bg-blue-100 p-1 rounded-full mr-3 mt-1">
                    <Check size={14} className="text-blue-600" />
                  </div>
                  <span>Expand across South India for a seamless travel experience</span>
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="text-center">
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-12 text-white">
            <h2 className="text-3xl font-bold mb-4">
              Ready for Your Next Journey?
            </h2>
            <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto">
              Experience the perfect blend of comfort, reliability, and exceptional service with Hyderabad's most trusted travel partner.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => openWhatsAppGeneral("booking a ride")}
                className="px-8 py-4 bg-gradient-to-r from-blue-500 to-blue-600 text-white font-bold rounded-lg hover:from-blue-600 hover:to-blue-700 transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.76.982.998-3.675-.236-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.9 6.994c-.004 5.45-4.438 9.88-9.888 9.88m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.333.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.333 11.893-11.893 0-3.18-1.24-6.162-3.495-8.411"/>
                </svg>
                Book Your Ride Now
              </button>
              <button className="px-8 py-4 bg-white text-gray-900 font-bold rounded-lg hover:bg-gray-100 transition-all duration-300">
                Download Brochure
              </button>
              <button 
                onClick={() => openWhatsAppGeneral("contacting you")}
                className="px-8 py-4 bg-transparent border-2 border-white text-white font-bold rounded-lg hover:bg-white/10 transition-all duration-300"
              >
                Contact Us
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutUs;